export const arrayParser = array => array;
//# sourceMappingURL=array.js.map
